import useVerify from '../../hook/useVerify';
import useDevice from '../../../hook/useDevice';
import ScrollToTop from '../../../components/ScrollToTop';
import useIdentifyCompany from '../../../ufood-x/hook/useIdentifyCompany';
import useColor from '../../../hook/useColor';

const Layout = (props) => {
  const { children, className } = props;
  console.log('UFOOD X Layout');

  useIdentifyCompany();
  useDevice();
  useColor();
  useVerify();

  return (
    <>
      <div className={`relative w-full h-full bg-white max-w-3xl mx-auto ${className?.first}`}>
        <div className={`m-4 pb-4 ${className?.second}`}>{children}</div>
      </div>
      <ScrollToTop />
    </>
  );
};

export default Layout;
